import axios, { AxiosInstance } from "axios";

// axios api client factory
let externalApiClient: AxiosInstance;
export const configureExternalApiClient = ({
  baseURL,
  headers,
  withCredentials,
}: {
  baseURL?: string;
  headers?: { [headerName: string]: string };
  withCredentials?: boolean;
}) => {
  externalApiClient = axios.create();
  externalApiClient.defaults.baseURL = baseURL;
  if (withCredentials)
    externalApiClient.defaults.withCredentials = withCredentials;

  if (headers) {
    Object.entries(headers).forEach(([key, value]) => {
      externalApiClient.defaults.headers[key] = value;
    });
  }
};

// Export the Axios instance
export const getExternalApiClient = (): AxiosInstance => {
  if (!externalApiClient) {
    // Ensure apiClient is initialized
    throw new Error(
      "API client is not configured. Please call `configureApiClient` first.",
    );
  }
  return externalApiClient;
};
